import { Chip } from "@mui/material";
import { getBookingStatus } from "../../../../utils/bookingStatus";

const StatusChip = ({ status, localDelivery = false }) => {

    const item = getBookingStatus(status, localDelivery);

    return (<Chip
        label={item?.label}
        sx={{
            background: item?.color,
            color: "#fff",
            fontWeight: 600,
            borderRadius: "8px"
        }}
    />);

};

export default StatusChip;
